exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "stage-config-field {\n  display: block;\n}\nstage-config-field label {\n  font-weight: 600;\n}\nstage-config-field label .help-contents {\n  font-weight: normal;\n}\n", ""]);

